<template>
  <div>
    <v-app-bar color="white">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="py-2">
        <v-img 
          height="100%" 
          position="left center"
          contain
          src="@/assets/logo.svg"
          alt="Logo"
        ></v-img>
      </v-toolbar-title>

      <v-spacer />      

      <v-toolbar-items>        
        <div 
          v-if="!Boolean(user)" 
          class="align-self-center"
        >
          <v-btn
            color="deep-purple darken-4"
            dark
            icon
            @click.stop="signIn"
          >
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </div>

        <div class="align-self-center" v-else>
          <v-menu
            v-model="userMenu"
            close-on-click
            close-on-content-click
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-avatar 
                size="36" 
                class="clickable" 
                v-on="on"
              >
                <img
                  :src="user.picture"
                  :alt="user.displayName"
                >
              </v-avatar>
            </template>

            <v-list>
              <v-list-item>
                <v-avatar 
                  size="36" 
                  class="clickable mr-3" 
                >
                  <img
                    :src="user.photoURL"
                    :alt="user.displayName"
                  >
                </v-avatar>

                <div>
                  <v-list-item-title>{{ user.displayName }}</v-list-item-title>
                  <v-list-item-subtitle v-if="user.admin">Administrateur</v-list-item-subtitle>
                </div>
              </v-list-item>
              
              <v-list-item>
                <v-btn
                  color="deep-purple darken-4"
                  text
                  @click.stop="signOut"
                >
                  <v-icon left>mdi-account-off</v-icon> Déconnexion
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-toolbar-items>
    </v-app-bar>
    
    <v-navigation-drawer 
      v-model="drawer" 
      disable-resize-watcher 
      app
      temporary
    >
      <div class="text-right pa-2">
        <v-icon class="clickable" @click.stop="drawer = false">mdi-close</v-icon>       
      </div>

      <v-list dense rounded>
        <div
          v-for="item in drawerItems"
          :key="item.name"
        >
          <v-list-item
            v-if="visibleNav(item)"
            :to="item.path"
            @click="navigatingTo(item)"
          >
            <v-list-item-action>
              <v-icon>{{ item.meta.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  computed: {
    user() { return this.$store.state.auth.user },
    drawerItems() { return this.$router.options.routes.filter(route => Boolean(route.meta.icon)) },
  },
  data: () => ({
    userMenu: false,
    drawer: false,
  }),
  methods: {
    navigatingTo(item) {
      if(this.$route.path === item.path) this.drawer = false
    },
    visibleNav(item) {
      let rC = item.meta.requiredClaims
      
      return  !Boolean(rC) || 
        //...ou, un usager est connecté et...
        (Boolean(this.user) && (
          //...le rôle d'admin n'est pas requis mais l'utilisateur a été vérifié...
          (Boolean(rC.some(claim => claim !== 'admin')) && Boolean(this.user.user_id) && Boolean(this.user.email_verified)) ||
          //...le rôle d'admin est pas requis et l'utilisateur est un admin
          (Boolean(rC.some(claim => claim === 'admin')) && Boolean(this.user.admin))
        ))
    },
    toggleUserMenu() {
      this.userMenu = !this.userMenu
      return
    },
    signIn() {
      this.$store.dispatch('auth/signIn')
    },
    signOut() {
      this.$store.dispatch('auth/signOut')
    },
  },
}
</script>

<style scoped>
.v-toolbar__title {
  height: 100%;
}
</style>